import {
  LocalDateTimeString,
  LocalDateString,
  Workday,
  OfficeWorkday,
  Workspace,
  GetReservationCountQuery,
} from './apiTypes';
import {OfficeWorkdayParams} from './selectors';
import {ReservationData} from './stateTypes';

export const getPendingKeysOwnedByRequest = <TKey extends string, TReservation>(
  keys: Array<TKey>,
  record: Record<TKey, ReservationData<TReservation> | undefined>,
  requestId: string,
): Array<TKey> => {
  return keys.filter((k) => {
    const entry = record[k];
    if (!entry) throw new Error('Key does not appear in record; it must be owned by someone');

    if (entry.status !== 'pending') return false;

    return entry.status === 'pending' && entry.requestId === requestId;
  });
};

export const wait = (ms = 200, label?: string) => {
  return new Promise((res, rej) => {
    if (label) console.log(`${label} (delay=${ms})`);
    setTimeout(res, ms);
  });
};
export const dateOverlapsWithReservation = (
  localStart: LocalDateTimeString,
  localEnd: LocalDateTimeString,
  date: LocalDateString,
) => {
  if (localEnd < `${date}T00:00`) return false;
  if (localStart > `${date}T23:59`) return false;
  return true;
};

export const isOfficeWorkday = (wd: Workday): wd is OfficeWorkday => {
  return wd.status === 'OfficeDay';
};

export const workspaceAreaOrFloorOrBuilding = (workspace: Workspace) => {
  if ('areaName' in workspace) return workspace.areaName;
  if ('floorName' in workspace) return workspace.floorName;
  return workspace.buildingName;
};

export const workspacesAreInSameLocation = (a: Workspace, b: Workspace) => {
  // Exact match
  if (a.nodeId === b.nodeId) return true;

  // Desks in same area
  if (a.nodeType === 'Desk' && b.nodeType === 'Desk') return a.areaId === b.areaId;

  return false;
};

export const reservationCountQueryKey = (q: GetReservationCountQuery): string => {
  return `${q.nodeId}_${q.startDate}_${q.endDate}`;
};

export const reservationCountQueryForWorkday = (workday: OfficeWorkdayParams): GetReservationCountQuery => {
  return {
    nodeId: workday.buildingId,
    startDate: workday.localStart,
    endDate: workday.localEnd,
  };
};
